<template>
  <b-modal
    ref="trade-in-qc-modal"
    id="trade-in-qc-modal"
    size="lg"
    title="Kiểm định máy thu cũ"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <p class="mb-3">
      Chọn xử lý cho từng máy. Máy đưa vào tồn kho thu cũ sẽ không bán được và
      được tự động tạo phiếu chuyển kho về kho đã chọn.
    </p>
    <div class="mb-3">
      <b-button
        size="sm"
        variant="outline-success"
        class="mr-2"
        :disabled="loading"
        @click="setAll(DECISION.APPROVE)"
      >
        Duyệt bán tất cả
      </b-button>
      <b-button
        size="sm"
        variant="outline-warning"
        :disabled="loading"
        @click="setAll(DECISION.TRADE_IN_STOCK)"
      >
        Đưa tất cả vào tồn kho thu cũ
      </b-button>
    </div>
    <table class="table table-bordered table-vertical-center">
      <thead>
        <tr>
          <th>Sản phẩm</th>
          <th>IMEI</th>
          <th style="width: 40%">Xử lý</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in items" :key="row.imei">
          <td>{{ row.productName }}</td>
          <td>{{ row.imei }}</td>
          <td>
            <b-form-radio-group
              v-model="decisions[row.imei]"
              :options="decisionOptions"
              :disabled="loading"
              stacked
            />
          </td>
        </tr>
      </tbody>
    </table>
    <b-form-group v-if="hasTradeInStock">
      <template #label>
        <span>Kho chuyển đến:</span>
        <span class="text-danger">*</span>
      </template>
      <Autosuggest
        :model="searchStore"
        :suggestions="filteredStores"
        placeholder="Chọn kho (kho Lỗi)"
        :limit="200"
        suggestionName="suggestionName"
        @select="onSelectStore"
        @change="onSearchStore"
      />
    </b-form-group>
    <template #modal-footer>
      <b-button
        size="sm"
        variant="secondary"
        :disabled="loading"
        @click="onCancel"
      >
        Hủy
      </b-button>
      <b-button
        size="sm"
        variant="primary"
        :disabled="!canConfirm || loading"
        @click="onConfirm"
      >
        Xác nhận
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

// t103002: lựa chọn cho từng IMEI sau khi bấm Lưu phiếu nhập máy cũ
const DECISION = Object.freeze({
  APPROVE: 1, // Duyệt bán - vào tồn bán như cũ
  TRADE_IN_STOCK: 2, // Đưa vào tồn kho thu cũ - tự tạo phiếu chuyển về kho đã chọn
});

export default {
  components: { Autosuggest },
  props: {
    // [{ imei, productName }]
    items: {
      type: Array,
      default: () => [],
    },
    // danh sách kho từ API stores: [{ id, name, shortName }]
    stores: {
      type: Array,
      default: () => [],
    },
    sourceStoreId: {
      type: [Number, String],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DECISION,
      decisionOptions: [
        { text: 'Duyệt bán', value: DECISION.APPROVE },
        { text: 'Đưa vào tồn kho thu cũ', value: DECISION.TRADE_IN_STOCK },
      ],
      decisions: {},
      searchStore: '',
      destinationStoreId: null,
      filteredStores: [],
    };
  },
  computed: {
    storeOptions() {
      return this.stores
        .filter((store) => Number(store.id) !== Number(this.sourceStoreId))
        .map((store) => ({
          ...store,
          suggestionName: `${store.shortName} ( ${store.name})`,
        }));
    },
    rejectedImeis() {
      return this.items
        .map((row) => row.imei)
        .filter((imei) => this.decisions[imei] === DECISION.TRADE_IN_STOCK);
    },
    hasTradeInStock() {
      return this.rejectedImeis.length > 0;
    },
    canConfirm() {
      const allDecided = this.items.every((row) => !!this.decisions[row.imei]);
      return allDecided && (!this.hasTradeInStock || !!this.destinationStoreId);
    },
  },
  methods: {
    show() {
      // Mỗi lần mở phải chọn lại từ đầu - không chọn sẵn để nhân viên buộc phải quyết định
      this.decisions = this.items.reduce((result, row) => {
        result[row.imei] = null;
        return result;
      }, {});
      this.searchStore = '';
      this.destinationStoreId = null;
      this.filteredStores = [...this.storeOptions];
      this.$refs['trade-in-qc-modal'].show();
    },
    hide() {
      this.$refs['trade-in-qc-modal'].hide();
    },
    setAll(decision) {
      this.items.forEach((row) => this.$set(this.decisions, row.imei, decision));
    },
    onSelectStore(option) {
      if (!option || !option.item) return;
      this.searchStore = option.item.suggestionName;
      this.destinationStoreId = option.item.id;
    },
    onSearchStore(text) {
      this.searchStore = text;
      this.destinationStoreId = null;
      const keyword = (text || '').toLowerCase();
      this.filteredStores = this.storeOptions.filter(
        (store) =>
          store.name.toLowerCase().includes(keyword) ||
          store.shortName.toLowerCase().includes(keyword),
      );
    },
    onCancel() {
      this.hide();
      this.$emit('cancel');
    },
    onConfirm() {
      if (!this.canConfirm) return;
      this.$emit('confirm', {
        rejectedImeis: this.rejectedImeis,
        destinationStoreId: this.hasTradeInStock ? this.destinationStoreId : null,
      });
    },
  },
};
</script>
